import { UserStatus } from '@models/user.model'

export class Authenticate {
	username?: string
	token: string
	refreshToken: string
	expiresIn: number
	expireAt: string
	status?: UserStatus
	deviceKey?: string
	deviceGroupKey?: string
	devicePassword?: string

	constructor(source?: Partial<Authenticate>) {
		if (source) {
			this.username = source.username
			this.token = source.token
			this.status = source.status
			this.expireAt = source.expireAt
			this.expiresIn = source.expiresIn
			this.refreshToken = source.refreshToken
			this.deviceKey = source.deviceKey
			this.deviceGroupKey = source.deviceGroupKey
			this.devicePassword = source.devicePassword
		}
	}
}
